export default __webpack_public_path__ + "static/media/kona2-front-black.b9d92639.png";